export default {
    getPatientAppointmentTableIsShow: state => state.patientAppointmentTableIsShow,
    getPatientDisbandTableIsShow: state => state.patientDisbandTableIsShow,
    getPatientAttendanceWrapperIsShow: state => state.patientAttendanceWrapperIsShow,

    getPatientAttendanceTableIsShow: state => state.patientAttendanceTableIsShow,
    getPatientAttendanceDetailsIsShow: state => state.patientAttendanceDetailsIsShow,

    getPatientEvidenceContentIsShow: state => state.patientEvidenceContentIsShow,
    getPatientEvidenceFormIsShow: state => state.patientEvidenceFormIsShow,
    getPatientEvidenceFormFinalizeIsShow: state => state.patientEvidenceFormFinalizeIsShow,
    isShowEHREvidenceForm: state => state.EHREvidenceFormIsShow,
    getCovidRapidAntigenTestFormIsShow: state => state.covidRapidAntigenTestFormIsShow,
    getVarandosagMegallapitasFields: state => state.varandosagMegallapitasFields,

    getPatientAppointmentTableAdditionalConfig : state => state.patientAppointmentTableAdditionalConfig,
    getPatientAppointmentTableActions : state => state.patientAppointmentTableActions,
    getPatientAppointmentTableRowActions : state => state.patientAppointmentTableRowActions,
    getPatientAppointmentTableSearchFields : state => state.patientAppointmentTableSearchFields,
    getPatientAppointmentTableHeaderFields : state => state.patientAppointmentTableHeaderFields,

    getPatientAttendanceTableRowActions: state => state.patientAttendanceTableRowActions,
    getPatientAttendanceTableHeaderFields: state => state.patientAttendanceTableHeaderFields,

    getPatientDisbandTableAdditionalConfig: state => state.patientDisbandTableAdditionalConfig,
    getPatientDisbandTableActions: state => state.patientDisbandTableActions,
    getPatientDisbandTableHeaderFields: state => state.patientDisbandTableHeaderFields,

    getPatientEvidenceDocumentRowActions: state => state.patientEvidenceDocumentRowActions,
    getPatientEvidenceDocumentHeaderFields: state => state.patientEvidenceDocumentHeaderFields,

    getEvidenceDocumentTableRowActions: state => state.evidenceDocumentTableRowActions,
    getEvidenceDocumentTableHeaderFields: state => state.evidenceDocumentTableHeaderFields,

    getEvidenceBnoHeaderFields: state => state.patientEvidenceBnoHeaderFields,

    getPatientAttendanceEkatalogusFormIsShow: state => state.patientAttendanceEKatalogusFormIsShow,

    getPatientCovidResutlHeaderFields: state => state.patientCovidResutlHeaderFields
}
